import React from 'react';
import PropTypes from 'prop-types';
import './UserMarketing.scss';
import Feed from 'components/Feed';


export default class UserMarketing extends React.Component {
    constructor (props) {
        super(props);
    }

    render() {


        const myAssets =[
            {
                title: 'NOON Fact Sheet',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-fact-sheet-5-pager-thumb.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-fact-sheet-5-pager.pdf',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'NOON Brand Guide',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-brand-guide-cover.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-brand-guide-080217.pdf',
                download: true,
                ctaLable: 'Download',
            },

        ];

        const myPhotos = [
            {
                title: 'NOON ',
                category: '| Director',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/Director.png',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/Director.png',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'NOON ',
                category: ' | Extension',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/Extension.png',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/Extension.png',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'NOON ',
                category: '| Three Gang',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-three-gang.png',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-three-gang.png',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'NOON ',
                category: '| Switches',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/IMAGE2.png',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/IMAGE2.png',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'NOON ',
                category: '| Switches',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/IMAGE3.png',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/IMAGE3.png',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'NOON ',
                category: '| Partners',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/IMAGE4_rev.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/IMAGE4_rev.jpg',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'NOON ',
                category: '| Switches',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/IMAGE5.png',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/IMAGE5.png',
                download: true,
                ctaLable: 'Download',
            },


        ];

        const myVideos = [
            {
                title: 'NOON ',
                category: '| How It Works',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-video-screen-web-temp.jpg',
                link: 'https://www.youtube.com/watch?v=qJYGIjKiics&feature=youtu.be',
                download: false,
                ctaLable: 'Watch Now',
            },
        ];

        const myLogos = [
            {
                title: 'NOON Dark Grey ',
                category: '| Pantone 2336C',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-logo-pms2336c.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-logo-pms2336c.jpg',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'NOON Grey ',
                category: '| Pantone 2333C',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-logo-grey.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-logo-grey.jpg',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'NOON Dark Grey ',
                category: '| Pantone 548C',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-logo-blue.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/noon-logo-blue.jpg',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'Authorized NOON Installer',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/Authorized_badge_installer.png',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/Authorized_badge_installer.png',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'Authorized NOON Dealer',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/Authorized_dealer_badge.png',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/marketing/Authorized_dealer_badge.png',
                download: true,
                ctaLable: 'Download',
            },
        ];


        return(
            <section className='marketing--container'>
                <h1>Marketing</h1>
                <p>Photography, video, logos and fact sheet available below. Can't find what you need? Email <a className='mail-link' href="mailto:pro@noonhome.com"> pro@noonhome.com.</a></p>
                <h6 className='marketing-section-title'>Media Assets</h6>
                <Feed proFeeds={myAssets}/>
                <h6 className='marketing-section-title'>Photos</h6>
                <Feed proFeeds={myPhotos}/>
                <h6 className='marketing-section-title'>Videos</h6>
                <Feed proFeeds={myVideos}/>
                <h6 className='marketing-section-title'>Logos</h6>
                <Feed proFeeds={myLogos}/>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserMarketing/index.js